import { computed } from 'vue'
import { useAccountCapabilitiesStore } from '@/stores/accountCapabilities'
import { useAccountSettingsStore } from '@/stores/accountSettings'
import {
  buildPricingHubLaunchUrl,
  PRICING_HUB_HOME_PATH,
  PRICING_HUB_INSPECTOR_PATH,
} from '@/utils/pricingHubLaunch'

// Single place that reads the stores to build Pricing Hub launch URLs (INT-013).
// The account is always the ISE-selected account, never row data.
export function usePricingHubLaunch() {
  const capabilities = useAccountCapabilitiesStore()
  const accountSettings = useAccountSettingsStore()

  const buildUrl = (path: string, query?: Record<string, string>): string | undefined => {
    if (!capabilities.hasLoaded || !capabilities.pricingHubEnabled) return undefined

    return buildPricingHubLaunchUrl({
      baseUrl: String(capabilities.pricingHubUrl ?? ''),
      path,
      query,
      token: String(accountSettings.sessionToken ?? ''),
      accountId: String(accountSettings.accountId ?? ''),
      role: String(accountSettings.userRole ?? ''),
    })
  }

  const homeUrl = computed(() => buildUrl(PRICING_HUB_HOME_PATH))
  const isAvailable = computed(() => homeUrl.value !== undefined)

  const inspectorUrlForVin = (vin: string): string | undefined => {
    const trimmedVin = String(vin ?? '').trim()
    if (!isAvailable.value || !trimmedVin) return undefined

    return buildUrl(PRICING_HUB_INSPECTOR_PATH, { vin: trimmedVin })
  }

  return { isAvailable, homeUrl, inspectorUrlForVin }
}
